import React from 'react';
import { theme } from '../../config/theme';

const SelectInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  options = [],
  placeholder = 'Select...',
  error,
  touched,
  required = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const showError = touched && error;

  const selectStyles = {
    width: '100%',
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    fontSize: theme.typography.fontSize.sm,
    color: value ? theme.colors.text.primary : theme.colors.text.secondary,
    backgroundColor: disabled ? theme.colors.gray[50] : theme.colors.white,
    border: `1px solid ${showError ? theme.colors.error : theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    outline: 'none',
    transition: theme.transitions.base,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: theme.typography.fontFamily,
  };

  const labelStyles = {
    display: 'block',
    marginBottom: theme.spacing.xs,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.colors.text.primary,
  };

  const errorStyles = {
    marginTop: theme.spacing.xs,
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.error,
  };

  return (
    <div className={className} style={{ marginBottom: theme.spacing.md }}>
      {label && (
        <label htmlFor={name} style={labelStyles}>
          {label}
          {required && <span style={{ color: theme.colors.error }}> *</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        style={selectStyles}
        onFocus={(e) => {
          if (!disabled) e.target.style.borderColor = theme.colors.primary.main;
        }}
        onBlurCapture={(e) => {
          if (!showError && !disabled) e.target.style.borderColor = theme.colors.gray[300];
        }}
        {...props}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {showError && <div style={errorStyles}>{error}</div>}
    </div>
  );
};

export default SelectInput;